import * as React from 'react';
import {InputLabel, ValidationSummary} from 'ui';

export const DisplayControlContext = props => ( 
 <div id={props.componentId} className={props.className}>
    <ValidationSummary validationError={props.validation}/>
    <InputLabel {...props.label} />
    {props.children}
  </div>);
